import HomeView from "../views/HomeView.vue";
import auth from "../utils/auth";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "INBROS | Inicio",
    },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: {
      title: "INBROS | Acerca de",
    },
  },

  {
    path: "/aviso",
    name: "aviso",
    component: () =>
      import(/* webpackChunkName: "aviso" */ "../views/AvisoPrivacidad.vue"),
    meta: {
      title: "INBROS | Aviso de privacidad",
    },
  },

  {
    path: "/FAQ",
    name: "faq",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/PreguntasFrecuentes.vue"
      ),
    meta: {
      title: "INBROS | Preguntas Frecuentes",
    },
  },
  {
    path: "/vida",
    name: "vida",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroVida.vue"),
    meta: {
      title: "INBROS | Seguro de vida",
    },
  },
  {
    path: "/accidentes",
    name: "accidentes",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/AccidentesPersonales.vue"
      ),
    meta: {
      title: "INBROS | Accidentes Personales",
    },
  },
  {
    path: "/hogar",
    name: "hogar",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroHogar.vue"),
    meta: {
      title: "INBROS | Hogar",
    },
  },
  {
    path: "/ahorro",
    name: "ahorro",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroAhorro.vue"),
    meta: {
      title: "INBROS | Ahorro",
    },
  },
  {
    path: "/mascotas",
    name: "mascotas",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroMascotas.vue"),
    meta: {
      title: "INBROS | Mascotas",
    },
  },
  {
    path: "/viajes",
    name: "viajes",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroViajes.vue"),
    meta: {
      title: "INBROS | Viajes",
    },
  },
  {
    path: "/gastos-medicos",
    name: "gastos-medicos",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/GastosMedicos.vue"),
    meta: {
      title: "INBROS | Gastos Médicos",
    },
  },
  {
    path: "/auto",
    name: "auto",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroAuto.vue"),
    meta: {
      title: "INBROS | Auto",
    },
  },
  {
    path: "/responsabilidad-civil",
    name: "ResponsabilidadCivil",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroRespon.vue"),
    meta: {
      title: "INBROS | Responsabilidad Civil",
    },
  },
  {
    path: "/flotillas",
    name: "Flotillas",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroFlotillas.vue"),
    meta: {
      title: "INBROS | Flotillas",
    },
  },
  {
    path: "/paquete-empresarial",
    name: "PaqueteEmpresarial",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroEmpresarial.vue"),
    meta: {
      title: "INBROS | Paquete empresarial",
    },
  },
  {
    path: "/seguro-de-vida-colectivo",
    name: "VidaColectivo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroVidaCol.vue"),
    meta: {
      title: "INBROS | Vida colectivo",
    },
  },
  {
    path: "/gastos-medicos-colectivo",
    name: "GastosMedicosCol",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroMedCol.vue"),
    meta: {
      title: "INBROS | Gastos médicos colectivo",
    },
  },
  {
    path: "/aviacion",
    name: "Aviacion",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroAviacion.vue"),
    meta: {
      title: "INBROS | Aviación",
    },
  },
  {
    path: "/embarcaciones",
    name: "Embarcaciones",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/SeguroEmbarcaciones.vue"
      ),
    meta: {
      title: "INBROS | Embarcaciones",
    },
  },
  {
    path: "/transporte",
    name: "transporte",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroTransporte.vue"),
    meta: {
      title: "INBROS | Transporte",
    },
  },
  {
    path: "/accidentes-colectivo",
    name: "AccidentesColectivo",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/SeguroAccidentesCol.vue"
      ),
    meta: {
      title: "INBROS | Accidentes colectivo",
    },
  },
  {
    path: "/construccion",
    name: "Construccion",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroConstruccion.vue"),
    meta: {
      title: "INBROS | Construcción",
    },
  },
  {
    path: "/terrorismo",
    name: "Terrorismo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroTerrorismo.vue"),
    meta: {
      title: "INBROS | Terrorismo",
    },
  },
  {
    path: "/ciberseguridad",
    name: "Ciberseguridad",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroCiberseg.vue"),
    meta: {
      title: "INBROS | Ciberseguridad",
    },
  },
  {
    path: "/fianzas",
    name: "Fianzas",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroFianzas.vue"),
    meta: {
      title: "INBROS | Fianzas",
    },
  },
  {
    path: "/especiales",
    name: "espciales",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeguroEspeciales.vue"),
    meta: {
      title: "INBROS | Especiales",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginView.vue"),
    meta: {
      title: "INBROS | Inicio sesión",
    },
  },
  {
    path: "/busqueda",
    name: "SearchResults",
    component: () => import("@/views/SearchResults.vue"),
    meta: {
      title: "INBROS | Resultados búsqueda",
    },
  },
  {
    path: "/dashboard/inicio",
    name: "DashboardView",
    component: () => import("@/views/DashboardView.vue"),
    meta: {
      title: "INBROS | Dashboard Inicio",
    },
  },
  {
    path: "/dashboard/inicio",
    name: "DashboardView",
    component: () => import("@/views/DashboardView.vue"),
    meta: {
      title: "INBROS | Dashboard Inicio",
      requiresAuth: true, // 👈 Esto activa la protección
    },
  },
  {
    path: "/CotizadorHogar",
    name: "CotizadorHogar",
    component: () => import("@/views/SeguroHogarForm.vue"),
    meta: {
      title: "INBROS | Cotizador Hogar",
    },
  },
  {
    path: "/CotizadorAuto",
    name: "CotizadorAuto",
    component: () => import("@/views/CotizarAutoView.vue"),
    meta: {
      title: "INBROS | Cotizador Auto",
    },
  },
  {
    path: "/reportar-siniestro",
    name: "ReportarSiniestroTelefonico",
    component: () => import("@/views/ReportarSiniestroTelefonico.vue"),
  },
];

import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
  },
});

// 🛡️ Aquí va la guardia global
router.beforeEach((to, from, next) => {
  var isTokenValid = auth.isTokenValid();
  //console.log('isTokenValid: '+isTokenValid);
  if (to.meta.requiresAuth && !isTokenValid) {
    next("/"); // redirige al login si no está logueado
  } else {
    next(); // deja pasar
  }
});

// Actualizar el título
router.afterEach((to) => {
  const defaultTitle = "INBROS";
  document.title = to.meta.title || defaultTitle;
});

export default router;
